import { render } from "./PromosionList.vue?vue&type=template&id=0faaa873&scoped=true"
import script from "./PromosionList.vue?vue&type=script&lang=js"
export * from "./PromosionList.vue?vue&type=script&lang=js"

import "./PromosionList.vue?vue&type=style&index=0&id=0faaa873&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0faaa873"]])

export default __exports__